module.exports = __webpack_public_path__ + "img/data_moun_ly.e187eae7.png";